import { FC } from 'react';

import { Path, Svg, type SvgProps } from './svg';

export const Reservation: FC<SvgProps> = (props) => (
	<Svg width={24} height={24} viewBox="0 0 24 24" {...props}>
		<Path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M8 2C8.55228 2 9 2.44772 9 3V4H15V3C15 2.44772 15.4477 2 16 2C16.5523 2 17 2.44772 17 3V4H19C20.6569 4 22 5.34315 22 7V19C22 20.6569 20.6569 22 19 22H5C3.34315 22 2 20.6569 2 19V7C2 5.34315 3.34315 4 5 4H7V3C7 2.44772 7.44772 2 8 2ZM7 6H5C4.44772 6 4 6.44772 4 7V19C4 19.5523 4.44772 20 5 20H19C19.5523 20 20 19.5523 20 19V7C20 6.44772 19.5523 6 19 6H17V7C17 7.55228 16.5523 8 16 8C15.4477 8 15 7.55228 15 7V6H9V7C9 7.55228 8.55228 8 8 8C7.44772 8 7 7.55228 7 7V6ZM12 10C12.5523 10 13 10.4477 13 11V12.5H14.5C15.0523 12.5 15.5 12.9477 15.5 13.5C15.5 14.0523 15.0523 14.5 14.5 14.5H13V16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16V14.5H9.5C8.94772 14.5 8.5 14.0523 8.5 13.5C8.5 12.9477 8.94772 12.5 9.5 12.5H11V11C11 10.4477 11.4477 10 12 10Z"
			fill="currentColor"
		/>
	</Svg>
);
